import { render, staticRenderFns } from "./emarticonRegistrationPopup.vue?vue&type=template&id=f28e0b76&scoped=true"
import script from "./emarticonRegistrationPopup.vue?vue&type=script&lang=js"
export * from "./emarticonRegistrationPopup.vue?vue&type=script&lang=js"
import style0 from "./emarticonRegistrationPopup.vue?vue&type=style&index=0&id=f28e0b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28e0b76",
  null
  
)

export default component.exports